import React from "react";
import '../styles/header.css';
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'

export default class Header extends React.Component {

    render() {
        return (
                <Navbar className="customHeader sticky-inner" expand="lg">
                    <Navbar.Brand className="customTitle" onClick={()=>this.props.goToLink("home-link")}>
                        CA Siddharth S. Dwivedi & Co.</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto">
                            <Nav.Link onClick={()=>this.props.goToLink("home-link")}>Home</Nav.Link>
                            <Nav.Link onClick={()=>this.props.goToLink("services-link")}>Services</Nav.Link>
                            <Nav.Link onClick={() => this.props.goToLink("about-link")}>About Us</Nav.Link>
                            {/*<Nav.Link onClick={() => this.props.goToLink("contact-link")}>Contact Us</Nav.Link>*/}
                            <Nav.Link onClick={() => this.props.goToLink("locate-link")}>Locate Us</Nav.Link>
                        </Nav>
                        {/*<Nav className="float-right">*/}
                            {/*<a href="https://wa.me/919892079970" target="_blank">*/}
                                {/*<i className="fa fa-whatsapp fa-2x" style={{color: 'green'}}/>*/}
                                {/*<span className="right-content-header">WhatsApp us today!</span></a>*/}
                        {/*</Nav>*/}
                    </Navbar.Collapse>
                </Navbar>

        )
    }
}
